import React from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import DataTable from '../../../components/DataTable';


const Transactions = () => {
    const { debug } = useParams();

    return (
        <Tabs defaultActiveKey="success" id="uncontrolled-tab-example" className="mb-3">
            <Tab eventKey="success" title="Success">
                <DataTable
                    title="Transactions"
                    header={["Institution", "Job", "ATOM ID", "Date", "Amount", "Method"]}
                    url="payments/"
                    filters='status=S&fields=id,institution,job,atom_txnid,date_time,amt'
                    column={["institution", "job", "atom_txnid", "date_time", "amt", "pay_method"]}
                    edit={false}
                    multiDelete={debug ? true : false}
                />
            </Tab>
            <Tab eventKey="pending" title="Pending">
                <DataTable
                    title="Transactions"
                    header={["Institution", "Job", "Date", "Amount"]}
                    url="payments/"
                    filters='status=PEN&fields=id,institution,job,date_time,amt'
                    column={["institution", "job", "date_time", "amt"]}
                    edit={false}
                    multiDelete={debug ? true : false}
                />
            </Tab>
            <Tab eventKey="failed" title="Failed">
                <DataTable
                    title="Transactions"
                    header={["Institution", "Job", "Date", "Amount", "Note"]}
                    url="payments/"
                    filters='status=F&fields=id,institution,job,date_time,amt,note'
                    column={["institution", "job", "date_time", "amt", "note"]}
                    edit={false}
                    multiDelete={debug ? true : false}
                />
            </Tab>
        </Tabs>
    );
};

export default Transactions;